var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDrippingNotificationAvatar = function SvgDrippingNotificationAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#7C5EE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15c0-1.64 1.313-3 3-3h7.313c.562 0 1.171.281 1.593.703l5.39 5.39c.423.423.704 1.032.704 1.595V33c0 1.688-1.36 3-3 3H18c-1.688 0-3-1.313-3-3V15Zm16.5 6h-5.25A2.221 2.221 0 0 1 24 18.75V13.5h-6c-.844 0-1.5.703-1.5 1.5v18c0 .844.656 1.5 1.5 1.5h12c.797 0 1.5-.656 1.5-1.5V21Zm-.234-1.828-5.438-5.438c-.094-.093-.234-.14-.328-.187v5.203c0 .422.328.75.75.75h5.203c-.047-.094-.094-.234-.187-.328Z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDrippingNotificationAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/drippingNotificationAvatar.svg";